import { createSelector } from 'reselect';

const getSimilarSearchData = state => {
  return state;
};

export const selectOtherBranchesData = createSelector(
  getSimilarSearchData,
  data => data.SimilarSearchReducer.otherBranchesData
);

export const selectMoreLikeThisData = createSelector(
  getSimilarSearchData,
  data => data.SimilarSearchReducer.moreLikeThisData
);

export const selectMoreLikeThisDataTotalCount = createSelector(
  getSimilarSearchData,
  data => data.SimilarSearchReducer.moreLikeThisTotalResult
);
